export type ProfessionalCalendarView = 'WEEK' | 'MONTH';

const STORAGE_KEY = 'plumaa_professional_calendar_view';

export const getStoredProfessionalCalendarView =
	(): ProfessionalCalendarView => {
		try {
			const stored = localStorage.getItem(STORAGE_KEY);
			if (stored === 'WEEK' || stored === 'MONTH') return stored;
		} catch {
			/* ignore quota / private mode */
		}
		return 'WEEK';
	};

export const setStoredProfessionalCalendarView = (
	view: ProfessionalCalendarView,
) => {
	try {
		localStorage.setItem(STORAGE_KEY, view);
	} catch {
		/* ignore */
	}
};
